angular.module('unica_feedback.feedback_controllers', [])

.controller('FeedbackBasicController',
	function(
		$rootScope, $scope, $stateParams,
		FileUploader, getBaseApiURL, Session,
		FeedbackDeleteService
	) {

	$scope.forms = {};

	$scope.uploader =  new FileUploader({
		removeAfterUpload: true,
		alias: 'files',
		url: getBaseApiURL + '/event/upload-feedback',
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$rootScope.feedbackData = {
		event_id: $stateParams.event_id,
		files: []
	};

	$scope.deleteWorkshopFeedback = function( feedbackId ) {
		$scope.showLoader();
		FeedbackDeleteService
			.deleteFeedback( feedbackId )
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.feedbackData = data;
				//$scope.showSuccessMsg('Feedbacke Workshop rimosso con successo!', '');
			});
	};

});


